import React, { Component } from 'react';
import { Email, Telefone } from '../../../Componentes';
import api from '@api';
import navigate from '@/utils/navigate';
export default class ListarConcedentesPropostos extends Component {
	constructor() {
		super();
		this.state = {
			listaDePropostas: [],
			loadingIds: [],
		};

		this.carregarListaDePropostas = this.carregarListaDePropostas.bind(this);
		this.efetivarProposta = this.efetivarProposta.bind(this);
		this.apagarProposta = this.apagarProposta.bind(this);
	}

	UNSAFE_componentWillMount() {
		this.carregarListaDePropostas();
	}

	carregarListaDePropostas() {
		api.concedentes.ListaPropostas()
			.then((listaDePropostas) => {
				this.setState({ listaDePropostas });
			})
			.catch((erro) => {
				console.log('erro', erro);
			});
	}

	efetivarProposta(proposta) {
		const concedente = {
			...proposta,
			identificacao_cadastral: proposta.identificacao_cadastral.codigo_de_cadastro,
			ativo: true,
		};

		api.concedentes.AtualizaConcedente(concedente.id, concedente)
			.then(() => {
				navigate('/');
			})
			.catch((erro) => {
				console.log('erro', erro);
			});
	}

	apagarProposta(id) {
		api.concedentes.RemovePropostaPelaId(id)
			.then(() => {
				this.setState(prevState => {
					const listaDePropostas = prevState.listaDePropostas.filter(proposta => proposta.id !== id);
					return { listaDePropostas };
				});
			})
			.catch((erro) => {
				console.log('erro', erro);
			});
	}

	linkParaBaixarAcordoDeCooperacao(id) {
		return `${api.concedentes.getBaseUrl()}/${id}/baixar`;
	}

	isLoading(id) {
		return this.state.loadingIds.includes(id);
	}

	setLoading(id) {
		this.setState(state => state.loadingIds.includes(id)
			? state
			: ({
				...state,
				loadingIds: [...state.loadingIds, id],
			}));
	}

	setLoaded(id) {
		this.setState(state => !state.loadingIds.includes(id)
			? state
			: ({
				...state,
				loadingIds: state.loadingIds.filter(v => v !== id),
			}));
	}

	async baixar(id) {
		const token = api.auth.accessToken();
		const link = this.linkParaBaixarAcordoDeCooperacao(id);

		this.setLoading(id);
		await fetch(link, {
			headers: {
				Authorization: `Bearer ${token}`,
			},
		})
			.then(res => res.arrayBuffer())
			.then(buffer => {
				const blob = new Blob([buffer], { type: 'application/pdf' });
				const blobUrl = URL.createObjectURL(blob);

				this.setState(prevState => {
					const { listaDePropostas } = prevState;

					const proposta = listaDePropostas.filter(proposta => proposta.id === id)[0];
					const propostaAtualizada = { ...proposta, blobUrl };

					const listaDePropostasAtualizada = listaDePropostas.reduce((listaNova, valorOriginal) => {
						listaNova.push(valorOriginal.id === id ? propostaAtualizada : valorOriginal);
						return listaNova;
					}, []);

					return ({
						...prevState,
						listaDePropostas: [...listaDePropostasAtualizada],
					});
				});
			});
		this.setLoaded(id);
	}

	render() {
		const { listaDePropostas } = this.state;

		return (
			<div>
				<h5>Relação de Propostas para Concedente</h5>
				<table className="table table-striped table-hover">
					<thead>
						<tr>
							<th />
							<th>Nome</th>
							<th>Contatos</th>
							<th>Endereço</th>
							<th></th>
						</tr>
					</thead>
					<tbody>
						{
							listaDePropostas.map((proposta, i) => (
								<tr key={proposta.id} title={proposta.observacoes}>
									<td>
										{i + 1}
									</td>
									<td>
										{proposta.nome}
										<div>
											<small>{proposta.identificacao_cadastral.tipo_de_cadastro}: {proposta.identificacao_cadastral.codigo_de_cadastro} | </small>
											<small>{proposta.ramo_atividade}</small>
										</div>
									</td>
									<td>
										<div><Telefone value={proposta.telefone} /></div>
										<div><Email value={proposta.email} /></div>
									</td>
									<td>
										{proposta.endereco.logradouro}, {proposta.endereco.bairro}, {proposta.endereco.cidade}-{proposta.endereco.uf} ({proposta.endereco.cep})
									</td>
									<td>
										{proposta.blobUrl === undefined
											? this.isLoading(proposta.id)
												? 'Baixando...'
												: <button onClick={() => this.baixar(proposta.id)}>Baixar</button>
											: <button onClick={() => window.open(proposta.blobUrl, '_blank')}>Abrir</button>
										}
										<button onClick={() => this.efetivarProposta(proposta)}>Efetivar</button>
										<button onClick={() => this.apagarProposta(proposta.id)}>Apagar</button>
									</td>
								</tr>
							))
						}
					</tbody>
				</table>
			</div>
		);
	}
}
